<template>
  <v-card class="validate-sasv-modal">
    <v-card-title>{{ $t('admin_sasv.validate_title') }}</v-card-title>
    <v-card-text class="pa-2">
      <v-form ref="sasvForm" v-if="sasv">
        <v-text-field outlined
                      :label="$t('admin_sasv.octopus_no')"
                      v-model="sasv.octopus_no"
                      v-mask="'########?#?#'"
                      :rules="requiredRules"></v-text-field>
        <v-text-field outlined
                      :label="$t('admin_sasv.surname')"
                      v-model="sasv.surname"
                      :rules="requiredRules"></v-text-field>
        <v-text-field outlined
                      :label="$t('admin_sasv.given_name')"
                      v-model="sasv.given_name"
                      :rules="requiredRules"></v-text-field>
        <v-text-field v-if="sasv.other_company_name"
                      readonly
                      :label="$t('admin_sasv.other_company_name')"
                      :value="sasv.other_company_name"></v-text-field>
        <v-autocomplete outlined
                        :label="$t('admin_sasv.company')"
                        :placeholder="$t('admin_sasv.company')"
                        :items="companyOptions"
                        v-model="selectedCompanyId"
                        :rules="companyIdRules"
                        clearable
                        :disabled="createNewCompany">
        </v-autocomplete>
        <v-checkbox light
                    :label="$t('admin_sasv.create_new_company')"
                    v-model="createNewCompany">
        </v-checkbox>
        <v-row v-if="createNewCompany">
          <v-col>
            <v-text-field outlined
                          :label="$t('admin_sasv.new_company_name_en')"
                          :placeholder="$t('admin_sasv.new_company_name_en')"
                          v-model="newCompanyNameEn"
                          :rules="companyNameRules"></v-text-field>
          </v-col>
          <v-col>
            <v-text-field outlined
                          :label="$t('admin_sasv.new_company_name_zh')"
                          :placeholder="$t('admin_sasv.new_company_name_zh')"
                          v-model="newCompanyNameZh"
                          :rules="companyNameRules"></v-text-field>
          </v-col>
        </v-row>

        <v-text-field readonly
                      :label="$t('admin_sasv.source')"
                      :value="$t(`sasv_source.${sasv.source}`)"></v-text-field>
        <v-text-field readonly
                      :label="$t('admin_sasv.id_type')"
                      :value="$t(`id_type.${sasv.id_type}`)"></v-text-field>
        <viewer :options="viewerOptions"
                :images="photos"
                @inited="onViewerInit">
          <template slot-scope="{images}">
            <img v-for="src in images"
                 :key="src"
                 :src="src"
                 style="display: none">
          </template>
        </viewer>

        <v-input>
          <v-container fluid class="flex-column pa-0">
            <legend class="v-label theme--light">{{ $t('admin_sasv.octopus_front') }}</legend>
            <v-img contain
                   :src="getURL(sasv.octopus_front)"
                   max-height="300px"
                   @click="showImage(0)"></v-img>
          </v-container>
        </v-input>
        <v-input>
          <v-container fluid class="flex-column pa-0">
            <legend class="v-label theme--light">{{ $t('admin_sasv.octopus_back') }}</legend>
            <v-img contain
                   :src="getURL(sasv.octopus_back)"
                   max-height="300px"
                   @click="showImage(1)"></v-img>
          </v-container>
        </v-input>
        <!--        <v-row v-if="sasv.id_type === 'PERSONAL_OCTOPUS_AND_STAFF_CARD'">-->
        <!--          <v-col>-->
        <!--            <v-input>-->
        <!--              <v-container fluid class="flex-column pa-0">-->
        <!--                <legend class="v-label theme&#45;&#45;light">{{ $t('admin_sasv.staff_card_front') }}</legend>-->
        <!--                <v-img contain-->
        <!--                       :src="getURL(sasv.staff_card_front)"-->
        <!--                       max-height="300px"-->
        <!--                       @click="showImage(2)"></v-img>-->
        <!--              </v-container>-->
        <!--            </v-input>-->
        <!--          </v-col>-->
        <!--          <v-col>-->
        <!--            <v-input>-->
        <!--              <v-container fluid class="flex-column pa-0">-->
        <!--                <legend class="v-label theme&#45;&#45;light">{{ $t('admin_sasv.staff_card_back') }}</legend>-->
        <!--                <v-img contain-->
        <!--                       :src="getURL(sasv.staff_card_back)"-->
        <!--                       max-height="300px"-->
        <!--                       @click="showImage(3)"></v-img>-->
        <!--              </v-container>-->
        <!--            </v-input>-->
        <!--          </v-col>-->
        <!--        </v-row>-->

        <v-row v-if="duplicates">
          <v-col>
            <v-expansion-panels accordion>
              <v-expansion-panel>
                <v-expansion-panel-header>{{ $t('admin_sasv.duplicate_title') }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-data-table multi-sort
                                :items="duplicates"
                                :items-per-page="duplicates.length || 1"
                                :headers="sasvHeaders"
                                hide-default-footer>
                    <template #item.id_type="{value}">
                      {{ $t(`id_type.${value}`) }}
                    </template>
                    <template #item.validated_at="{value}">
                      {{ value ? $parseDate(value, 'yyyy-MM-dd') : '' }}
                    </template>
                    <template #item.status="{value}">
                      {{ $t(`sasv_status.${value}`) }}
                    </template>
                  </v-data-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions class="text-right">
      <v-btn @click="$emit('submit', undefined)"
             class="mr-3"
             depressed
             large>
        {{ $t('cancel') }}
      </v-btn>
      <v-spacer></v-spacer>

      <v-menu v-if="sasv"
              v-model="rejectReasonMenuShown"
              offset-y
              :close-on-content-click="false">
        <template v-slot:activator="{on, attrs}">
          <v-btn color="danger"
                 class="ml-4"
                 depressed
                 large
                 v-on="on">
            {{ $t('admin_sasv.reject') }}
          </v-btn>
        </template>

        <v-card>
          <v-card-text>
            <v-row>
              <v-col>
                <v-select v-model="rejectReason"
                          :items="rejectReasonOptions"
                          :label="$t('admin_sasv.reject_reason')"
                          :placeholder="$t('admin_sasv.reject_reason')"></v-select>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text
                   @click="rejectReasonMenuShown = false">
              {{ $t('cancel') }}
            </v-btn>
            <v-btn text color="danger"
                   class="ml-4"
                   depressed
                   large
                   @click="verifySasv(false)">
              {{ $t('admin_sasv.reject') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>

      <v-btn color="primary"
             class="ml-4"
             depressed
             large
             v-if="sasv"
             @click="$refs.sasvForm.validate() && verifySasv(true)">
        {{ $t('admin_sasv.accept') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import {computed, onMounted, ref, watch} from '@vue/composition-api';
import BGModal from "@/components/BGModal";

export default {
  name: 'ValidateSasvModal',
  components: {BGModal},
  props: {
    shown: Boolean,
    sasvId: String,
  },
  setup(props, {root, emit}) {
    const requiredRules = ref([
      value => !!value || root.$t('register.required_fields'),
    ]);

    onMounted(() => {
      getCompanies();
      getSasv();
    })

    // Init
    const getURL = function (f) {
      if (f instanceof File) {
        return URL.createObjectURL(f);
      } else {
        return 'api/static/' + f;
      }
    }

    // Form
    const sasv = ref(null);
    const getSasv = function () {
      root.$callAPI('sasv/admin/', {id: props.sasvId}, function (response) {
        sasv.value = response.body.sasv;
        duplicates.value = response.body.duplicates;
        selectedCompanyId.value = response.body.sasv.company ? response.body.sasv.company.id : null;

        let ph = [];
        [
          'octopus_front',
          'octopus_back',
          'staff_card_front',
          'staff_card_back',
        ].forEach((f) => {
          if (response.body.sasv[f]) {
            ph.push(getURL(response.body.sasv[f]));
          }
        })

        photos.value = ph;
      });
    };

    const selectedCompanyId = ref(null);
    const companyIdRules = computed(() => [
      value => (createNewCompany.value || !!value) || root.$t('register.required_fields'),
    ]);
    const companies = ref([]);
    const companyOptions = computed(() => {
      return companies.value.map((c) => {
        return {text: c.name_en + ' - ' + c.name_zh, value: c.id};
      })
    });
    const getCompanies = function () {
      root.$callAPI('hkiarace/admin/company/', {
        page_size: -1
      }, function (response) {
        companies.value = response.body.companies;
      });
    };

    const createNewCompany = ref(false);
    const newCompanyNameEn = ref(null);
    const newCompanyNameZh = ref(null);
    const companyNameRules = computed(() => [
      value => (!createNewCompany.value || !!value) || root.$t('register.required_fields'),
    ]);


    //
    const photos = ref([]);
    const viewer = ref(null);
    const viewerShown = ref(false);
    const showingImageIdx = ref(null);
    const onViewerInit = function (e) {
      viewer.value = e;
    };
    const viewerOptions = ref({
      inline: false,
      title: false,
      toolbar: {
        prev: {show: true, size: 'large'},
        next: {show: true, size: 'large'},
      },
      rotatable: false,
      zIndex: 303,

      // show(e) {
      //   viewerShown.value = true;
      // },
      // hide(e) {
      //   viewerShown.value = false;
      //   showingImageIdx.value = null;
      // },
      // viewed(e) {
      //   viewerShown.value = true;
      //   showingImageIdx.value = e.detail.index;
      // },
    });
    const showImage = function (index) {
      viewer.value.view(index);
    };

    const duplicates = ref([]);
    const sasvHeaders = ref([
      {text: root.$t('admin_sasv.octopus_no'), value: 'octopus_no'},
      {text: root.$t('admin_sasv.surname'), value: 'surname'},
      {text: root.$t('admin_sasv.given_name'), value: 'given_name'},
      {text: root.$t('admin_sasv.id_type'), value: 'id_type'},
      {text: root.$t('admin_sasv.company'), value: 'company.name'},
      {text: root.$t('admin_sasv.other_company_name'), value: 'other_company_name'},
      {text: root.$t('admin_sasv.status'), value: 'status', sortable: false},
      {text: root.$t('admin_sasv.validated_at'), value: 'validated_at', boolean: false},

      {text: '', value: 'actions', sortable: false},
    ]);

    const rejectReasonMenuShown = ref(false);
    const rejectReason = ref(null);
    const rejectReasonOptions = ref([
      {text: 'Invalid Airport Staff Octopus Card', value: 'Invalid Airport Staff Octopus Card'},
      {text: 'Invalid Card Number of Airport Staff Octopus', value: 'Invalid Card Number of Airport Staff Octopus'},
      {text: 'Invalid Name of Airport Staff Octopus Card', value: 'Invalid Name of Airport Staff Octopus Card'},
    ]);

    const verifySasv = function (decision) {
      if (decision && !confirm(root.$t('admin_sasv.confirm_accept_msg'))) {
        return;
      }

      if (!decision && !confirm(root.$t('admin_sasv.confirm_reject_msg'))) {
        return;
      }

      root.$callAPI('sasv/admin/verify/', {
        id: props.sasvId,
        decision: decision,
        octopus_no: sasv.value.octopus_no,
        surname: sasv.value.surname,
        given_name: sasv.value.given_name,
        company_id: createNewCompany.value ? null : selectedCompanyId.value,
        new_company_name_en: createNewCompany.value ? newCompanyNameEn.value : null,
        new_company_name_zh: createNewCompany.value ? newCompanyNameZh.value : null,
        reject_reason: decision ? null : rejectReason.value,
      }, () => {
        emit('submit', true);
      })
    };

    return {
      requiredRules,

      getURL,

      sasv,

      selectedCompanyId,
      companyIdRules,
      companyOptions,

      createNewCompany,
      newCompanyNameEn,
      newCompanyNameZh,
      companyNameRules,

      photos,
      viewerOptions,
      onViewerInit,
      viewerShown,
      showImage,

      duplicates,
      sasvHeaders,

      rejectReasonOptions,
      rejectReasonMenuShown,
      rejectReason,

      verifySasv,
    }
  },
}
</script>

<style lang="less">
.validate-sasv-modal {
  display: flex !important;
  flex-direction: column !important;
  height: 90vh;
  overflow: hidden;

  .v-card__text {
    flex: 1 1 0;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    width: 100% !important;
  }
}
</style>
